// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32_Yc","image":"Header_image__1iy10","name":"Header_name__HuFsC","info":"Header_info__3r-fK","infoRow":"Header_infoRow__31ElQ"};